import { render, staticRenderFns } from "./HKBankForm.vue?vue&type=template&id=51e78ba3&scoped=true&"
import script from "./HKBankForm.vue?vue&type=script&lang=js&"
export * from "./HKBankForm.vue?vue&type=script&lang=js&"
import style0 from "./HKBankForm.vue?vue&type=style&index=0&id=51e78ba3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e78ba3",
  null
  
)

export default component.exports